export default "__VITE_ASSET__B3l8nQoD__"